import {
  Component,
  OnInit,
  OnDestroy,
  EventEmitter,
  Input,
} from "@angular/core";
import { LoaderService } from "@app/core/services";
import { Subscription } from "rxjs";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: "loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.scss"]
})
export class LoaderComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() ref = "root";

  public showLoader: Boolean = false;

  constructor(private loaderService: LoaderService) { }

  ngOnInit() {
    this.checkState();
  }

  checkState() {
    this.loaderService
      .getLoadState(this.ref)
      .pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
        setTimeout(() => (this.showLoader = res));
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
